import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import flatpickr from 'flatpickr';
import 'swiper/css/thumbs';

const images = [
  '/images/resource/room-service1-1.jpg',
  '/images/resource/room-service1-2.jpg',
  '/images/resource/room-service1-3.jpg',
];

export default function RoomDetails() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const checkInRef = useRef(null),
    checkOutRef = useRef(null);

  useEffect(() => {
    const fpIn = flatpickr(checkInRef.current, { dateFormat: 'Y-m-d' });
    const fpOut = flatpickr(checkOutRef.current, { dateFormat: 'Y-m-d' });
    return () => {
      fpIn.destroy();
      fpOut.destroy();
    };
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle
        title="Room Details"
        breadcrumbs={[
          { label: 'Rooms', path: '/rooms' },
          { label: 'Room Details' },
        ]}
      />

      <section className="room-details-section pt-80 pb-60">
        <div className="auto-container">
          <div className="row">
            <div className="col-lg-8">
              <Swiper
                modules={[Navigation, Thumbs]}
                navigation
                loop
                thumbs={{
                  swiper:
                    thumbsSwiper && !thumbsSwiper.destroyed
                      ? thumbsSwiper
                      : null,
                }}
                className="room-details-slider-content mb-3"
              >
                {images.map((img, i) => (
                  <SwiperSlide key={i}>
                    <figure className="image">
                      <img
                        src={img}
                        alt=""
                        style={{ width: '100%', borderRadius: 8 }}
                      />
                    </figure>
                  </SwiperSlide>
                ))}
              </Swiper>
              <Swiper
                modules={[Thumbs]}
                onSwiper={setThumbsSwiper}
                loop
                slideToClickedSlide
                spaceBetween={10}
                slidesPerView={3}
                className="rdetails-thumbs mb-5"
              >
                {images.map((img, i) => (
                  <SwiperSlide key={i}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: '100%',
                        borderRadius: 6,
                        cursor: 'pointer',
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              <h2>China</h2>
              <p className="mb-4">
                Experience the pinnacle of luxury in our China. Featuring a
                king-size bed, stunning city views, and a private balcony.
                Perfect for couples and business travelers seeking comfort and
                elegance.
              </p>

              <div className="facilities-box d-flex flex-wrap gap-4 mb-5">
                {[
                  ['fal fa-bed', 'King Size Bed'],
                  ['fal fa-bath', 'Bathtub'],
                  ['fal fa-wifi', 'Free Wifi'],
                  ['fal fa-circle-user', '1-2 Persons'],
                  ['fal fa-tv', 'Smart TV'],
                  ['fal fa-snowflake', 'Air Conditioning'],
                ].map(([icon, label], i) => (
                  <div key={i} className="d-flex align-items-center gap-2">
                    <i className={icon}></i> <span>{label}</span>
                  </div>
                ))}
              </div>

              <h4>Room Policy</h4>
              <ul className="list-style-two">
                <li>
                  <i className="icon fa fa-circle-check"></i>Check-in from 3:00
                  PM, Check-out by 11:00 AM
                </li>
                <li>
                  <i className="icon fa fa-circle-check"></i>Pets not allowed
                </li>
                <li>
                  <i className="icon fa fa-circle-check"></i>No smoking inside
                  the room
                </li>
                <li>
                  <i className="icon fa fa-circle-check"></i>Complimentary
                  breakfast included
                </li>
              </ul>
            </div>

            {/* Booking Sidebar */}
            <div className="col-lg-4">
              <div
                className="p-4"
                style={{
                  background: '#f8f9fa',
                  borderRadius: 8,
                  position: 'sticky',
                  top: 100,
                }}
              >
                <h4 className="mb-1">
                  ₦30,000{' '}
                  <small style={{ fontSize: 14, fontWeight: 400 }}>
                    / Night
                  </small>
                </h4>
                <div className="star-rating mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className="fas fa-star"
                      style={{ color: '#FFB800', fontSize: 12 }}
                    ></i>
                  ))}
                </div>
                <div className="mb-3">
                  <label className="form-label">Check In</label>
                  <input
                    ref={checkInRef}
                    className="form-control date-pick"
                    placeholder="Select date"
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Check Out</label>
                  <input
                    ref={checkOutRef}
                    className="form-control date-pick"
                    placeholder="Select date"
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Guests</label>
                  <select className="form-select">
                    <option>1 Guest</option>
                    <option>2 Guests</option>
                  </select>
                </div>
                <Link
                  to="/contact"
                  className="theme-btn btn-style-one w-100 d-block text-center"
                >
                  <span className="btn-title">Book Now</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
